import { createContext, useReducer } from "react";
import { StorageService } from "../../services";
import { decryptAuthData } from "../../UtilityFunctions/utils";
import * as types from "./types";

const initialState = StorageService.get("token")
  ? decryptAuthData(StorageService.get("token")?.token)
  : {};

const authReducer = (state, action) => {
  switch (action.type) {
    case types.SET_AUTH:
      return {
        ...state,
        authData: action.payload,
      };
    case types.CLEAR_AUTH:
      return {};
    case types.SET_USER:
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export const AuthContext = createContext(initialState);

const AuthProvider = ({ children }) => {
  const [authState, authDispatch] = useReducer(authReducer, initialState);

  return (
    <AuthContext.Provider value={[authState, authDispatch]}>
      {children}
    </AuthContext.Provider>
  );
};

export default AuthProvider;
